import React from 'react';
import { SC } from '../../../styles/theme';
import { IFeatureSwitchContext } from '../../../context/featureSwitchApp';
import { ConfiguratorStyled } from '@components/v2/Configurator/ConfiguratorStyled';

export interface IConfigurator extends SC {
    initialFirstRender?: boolean;
}

export const Configurator = (props: IConfigurator) => <ConfiguratorStyled {...props} />;
